// Routes
const routes = [
  {
    path: '/',
    name: 'Home',
    component: () => import(/* webpackChunkName: "group-public" */ '@/views/Home.vue'),
  },
  {
    path: '/login',
    name: 'login',
    component: () => import(/* webpackChunkName: "group-public" */ '@/views/Login.vue'),
  },
]

export default routes
